module.exports = __webpack_public_path__ + "static/media/dobbi_bubles.65d8cd6a.svg";